module.exports = __webpack_public_path__ + "static/EDMantecaBlack-Regular-7815a88425606c2dfe5a08f1b7d147d1.woff2";